var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _this = this;
import React, { useEffect, useState } from 'react';
import { Autocomplete } from '@homeexchange/design';
import i18n from '../../../../i18n';
import AutocompleteService from '../../../../utils/AutocompleteService';
import Utils from '../../../../utils/utils';
import { PLACE_LAYERS } from '../../../../constants';
var debounce = function (func, wait) {
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new Promise(function (resolve) {
            var later = function () {
                timeout = null;
                resolve(func.apply(_this, args));
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        });
    };
};
var setReverseSearchAdminLevel = function () {
    if (PLACE_LAYERS.includes('macroregion')) {
        return 'county';
    }
    return 'macroregion';
};
var getFormattedResults = function (suggestions) {
    var result = {};
    suggestions.forEach(function (item) {
        result[item.formatedTitle] = item;
    });
    return result;
};
var getSuggestionsFromResults = function (results) {
    var sufix = 0;
    if (!results) {
        return null;
    }
    return Object.keys(results).map(function (item) {
        sufix++;
        return { value: item, id: sufix };
    });
};
var getPredictions = debounce(AutocompleteService.getPlaceSuggestions, 500);
export var ReverseSearchByLocation = function (_a) {
    var _b, _c;
    var onChange = _a.onChange, filters = _a.filters, isDisabled = _a.isDisabled;
    var _d = useState(null), predictions = _d[0], setPredictions = _d[1];
    var _e = useState((_c = (_b = filters.preferred_destination) === null || _b === void 0 ? void 0 : _b.address) !== null && _c !== void 0 ? _c : ''), inputValue = _e[0], setInputValue = _e[1];
    var onInputChange = function (value) {
        if (value !== '') {
            getPredictions(value)
                .then(function (predictions) {
                setPredictions(getFormattedResults(predictions));
            })
                .catch(function (error) {
                console.error('Error fetching predictions:', error);
            });
        }
        else {
            setPredictions(null);
        }
    };
    var onItemSelect = function (value) {
        var selectedPrediction = predictions[value];
        var bbox = selectedPrediction.bbox, layer = selectedPrediction.properties.layer;
        var currentFilters = JSON.parse(JSON.stringify(filters));
        var bounds = Utils.convertBboxToBounds(bbox);
        delete currentFilters.reverse;
        if (selectedPrediction) {
            var updatedFilters = __assign(__assign({}, currentFilters), { preferred_destination: {
                    bounds: bounds,
                    admin_level: layer === 'region' ? setReverseSearchAdminLevel() : layer,
                    address: value
                } });
            onChange(updatedFilters, false);
        }
        else if ('preferred_destination' in currentFilters) {
            delete currentFilters.preferred_destination;
            onChange(currentFilters, false);
        }
    };
    useEffect(function () {
        setInputValue('');
    }, [isDisabled]);
    return (React.createElement(Autocomplete, { suggestions: getSuggestionsFromResults(predictions) || [], onChange: function (value) {
            setInputValue(value);
            onInputChange(value);
        }, onSelect: onItemSelect, noSuggestionText: i18n.t('common:no_result'), inputIcon: "search-location-pin", itemsIcon: "search-location-pin", disabled: isDisabled, inputValue: inputValue, label: i18n.t('home:location_type') }));
};
